import { isLocaleValid } from "@payair/e-com-common-sdk/core/Validators";
import { ApplePayButtonColorEnumsObj } from "../enums/ApplePayButtonColorEnum";
import { ApplePayButtonTypeEnumsObj } from "../enums/ApplePayButtonTypeEnum";
/**
 * Apple Pay button paramaters type to control content and appearance of the button.
 */
var ApplePayButtonParams = /** @class */ (function () {
    function ApplePayButtonParams() {
    }
    return ApplePayButtonParams;
}());
export { ApplePayButtonParams };
/** @internal */
export var validateApplePayButtonParams = function (applePayButtonParams) {
    var errorMessage = [];
    if (!applePayButtonParams)
        errorMessage.push("applePayButtonParams not defined");
    else {
        if (!applePayButtonParams.buttonColor)
            errorMessage.push("buttonColor not defined");
        else if (!Object.values(ApplePayButtonColorEnumsObj).includes(applePayButtonParams.buttonColor))
            errorMessage.push("wrong buttonColor value");
        if (applePayButtonParams.buttonLocale && !isLocaleValid(applePayButtonParams.buttonLocale)) {
            errorMessage.push("buttonLocale not valid");
        }
        if (!applePayButtonParams.buttonType)
            errorMessage.push("buttonType not defined");
        else if (!Object.values(ApplePayButtonTypeEnumsObj).includes(applePayButtonParams.buttonType))
            errorMessage.push("wrong buttonType value");
        if (applePayButtonParams.buttonOnClick !== undefined && typeof applePayButtonParams.buttonOnClick !== "function")
            errorMessage.push("buttonOnClick is not a function");
    }
    return errorMessage;
};
